// @flow
const getServerError = (data?: any): ?string => data && (data[0] || data);

export default getServerError;
